import { Outlet } from "react-router-dom"



const Customers = () => {

    return<Outlet/>
}

export default Customers;